module.exports = __webpack_public_path__ + "static/media/icon_language_black.6a27c3cd.svg";